import { createApi } from './common/createApi'
import { apiBaseUrls } from '../constants/api-config'

const createConfiguredApi = (baseURL?: string) => createApi(baseURL ? { baseURL } : undefined)

export const apiClient = createConfiguredApi(apiBaseUrls.api)
export const authApiClient = createConfiguredApi(apiBaseUrls.auth)
export const graphApiClient = createConfiguredApi(apiBaseUrls.graph)
export const ideasbankApiClient = createConfiguredApi(apiBaseUrls.ideasbank)
export const pg3ApiClient = createConfiguredApi(apiBaseUrls.pg3Api)
